import React from 'react';
import PageContainer from 'common/components/PageContainer';
import {TaxAuthorityProvider} from "../../contexts/TaxAuthorityContext";
import TaxAuthorityTable from "../TaxAuthorityTable";

const TaxAuthorityPage = ({cities, streets, updateStreets}) => {

  return (
    <TaxAuthorityProvider cities={cities} streets={streets} updateStreets={updateStreets}>
      <PageContainer>
        <TaxAuthorityTable/>
      </PageContainer>
    </TaxAuthorityProvider>
  );
};

export default TaxAuthorityPage;